import { Popover } from "@components/tooltip/Popover";






export function MainFooter(){
  return (
    <div className="p-4 flex flex-col md:flex-row-reverse items-center gap-2 md:gap-7 text-gray-500">
        <div className="flex md:justify-end w-full">
        </div>
      <p className="md:text-nowrap ">
        © Copyright 2026
        <a className="ml-2 underline underline-offset-2 hover:text-white" href="http://fixransomware.com" target="_blank" rel="noopener noreferrer">
           FixRansomwareTeam
        </a>
        . All rights reserved.
      </p>
    </div>
  )
}